import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {Subject} from 'rxjs';

@Component({
  selector: 'curation-modal-message',
  templateUrl: './curation-modal-message.component.html',
  styleUrls: ['./curation-modal-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class CurationModalMessageComponent implements OnInit {

  public payload: {
      title: string;
      content:string;
  };

  public tunnel$: Subject<any>;
  public callback: () => void;
  public title: string;
  public content: string;

  constructor() { }

  ngOnInit() {
    this.title = this.payload && this.payload['title'] || '';
    this.content = this.payload && this.payload['content'] || '';

    this.tunnel$
      .asObservable()
      .filter(message => message.emitter != 'children' && message.value)
      .map(message => message.value)
      .subscribe((data) => {
        this.callback();
        this.tunnel$.next({ emitter: 'children', value: 1});
      });
  }
}
